/**
 * next/link shim for Vite + TanStack Router
 *
 * Wraps TanStack Router's <Link> to match Next.js's <Link href="..."> API.
 */
import { Link as RouterLink } from '@tanstack/react-router'
import type { ComponentPropsWithoutRef } from 'react'

interface NextLinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href'> {
  href: string
  replace?: boolean
  /** prefetch is a Next.js concept — TanStack Router prefetches on hover automatically */
  prefetch?: boolean | null
  children?: React.ReactNode
}

export default function Link({ href, replace, prefetch: _prefetch, children, ...rest }: NextLinkProps) {
  return (
    <RouterLink to={href} replace={replace} {...(rest as object)}>
      {children}
    </RouterLink>
  )
}
